import "./styles/shared.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import FreeGuide from "./pages/FreeGuide";
import FreeGuideThankYou from "./pages/FreeGuideThankYou";
import Bundle from "./pages/Bundle";
import BundleThankYou from "./pages/BundleThankYou";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/free-guide" element={<FreeGuide />} />
          <Route path="/free-guide/thank-you" element={<FreeGuideThankYou />} />
          <Route path="/bundle" element={<Bundle />} />
          <Route path="/bundle/thank-you" element={<BundleThankYou />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
